import {
  GetString,
} from 'fluent-react';
import React, { RefObject } from 'react';
import styled from 'styled-components';
import { SlideElementProps } from '../../presentationManager/PresentationManager';
import { VizType } from '../../viz/Utils';
import { placeholderBorderRadius } from '../graphControlDropdown';
import { GraphControlsContainer } from '../Grid';
import HelpTooltip from '../utilityBarItems/HelpTooltip';
import ExploreButton, { exploreButtonWidth } from './ExploreButton';

const Container = styled(GraphControlsContainer)`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  @media (max-width: 1080px) {
    display: none;
  }
`;

const ButtonWrapper = styled.div`
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.1);
  border-radius: ${placeholderBorderRadius};
  overflow: hidden;
`;

interface Props extends SlideElementProps {
  zIndex: number;
  year: number;
  countryId: string;
  vizType: VizType;
  getFluentString: GetString;
  isHelpActive: boolean;
  helpTooltipIndex: number;
}

const ExploreEngageButtons = React.forwardRef((props: Props, rootElRef: RefObject<HTMLDivElement>) => {
  const {
    zIndex,
    year, countryId, vizType, getFluentString,
    helpTooltipIndex, isHelpActive,
  } = props;

  return (
    <Container style={{zIndex}} ref={rootElRef}>
      <ButtonWrapper>
        <ExploreButton
          year={year}
          countryId={countryId}
          vizType={vizType}
          label={getFluentString('explore-in-the-atlas-button-text')}
        />
      </ButtonWrapper>
      <HelpTooltip
        index={helpTooltipIndex}
        term={getFluentString('help-tooltips-explore-button-title')}
        explanation={getFluentString('help-tooltips-explore-button-description')}
        isHelpActive={isHelpActive}
        styles={{transform: `translate(calc(-${exploreButtonWidth} - 50%), 50%)`}}
      />
    </Container>
  );
});

export default ExploreEngageButtons;
